import { render } from "./Doctors.vue?vue&type=template&id=345e58fc&ts=true&lang=pug"
import script from "./Doctors.vue?vue&type=script&setup=true&lang=ts"
export * from "./Doctors.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__